import { render, staticRenderFns } from "./editNft.vue?vue&type=template&id=47170b0a&"
import script from "./editNft.vue?vue&type=script&lang=js&"
export * from "./editNft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports